import React from 'react';
import SubPage from '../SubPage';
import { useLang } from '../../LanguageContext';
import HISTORY from './historyData';
import useSite from '../../useSite';

const CRUMB = { ko: '회사소개', en: 'About Us' };
const T = {
  title: { ko: '연혁', en: 'History' },
  lede:  { ko: '2021년 설립 이후 메디로지스가 걸어온 길입니다.',
           en: 'The path MEDILOGIS has taken since its founding in 2021.' },
  h2:    { ko: '데이터로 쌓아온 돌봄의 기록', en: 'A record of care, built on data' },
  note:  { ko: '※ 2021~2025년은 회사 공식 연혁 자료, 2026년은 보도 자료 기준입니다.',
           en: 'Note: 2021–2025 follows the official company record; 2026 is based on press releases.' },
};

function History() {
  const { lang } = useLang();
  // DB(SITE_HISTORY) 우선, 실패하면 코드에 남은 기존 데이터
  const rows = useSite('/api/site/history', null);
  const years = rows
    ? rows.reduce((acc, r) => {
        let y = acc.find((x) => x.year === String(r.YEAR));
        if (!y) { y = { year: String(r.YEAR), items: [] }; acc.push(y); }
        y.items.push({ html: (lang === 'en' && r.CONTENT_EN) ? r.CONTENT_EN : r.CONTENT });
        return acc;
      }, [])
    : HISTORY;
  return (
    <SubPage crumb={CRUMB[lang]} title={T.title[lang]} lede={T.lede[lang]}>
      <div className="sp-label">HISTORY</div>
      <h2>{T.h2[lang]}</h2>
      <div className="tl sp-mt">
        {years.map((y) => (
          <div className="tl-item" key={y.year}>
            <div className="tl-year">{y.year}</div>
            <ul>
              {y.items.map((it, i) => (
                it.html !== undefined
                  ? <li key={i} dangerouslySetInnerHTML={{ __html: it.html }} />
                  : <li key={i}>{it[lang] || it.ko}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="sp-note">{T.note[lang]}</div>
    </SubPage>
  );
}

export default History;
